import { ContactTitleEnum } from '@splitsecondconnect/ultramarine-shared';

export const CONTACT_TITLE = [
	{
		value: ContactTitleEnum.DR,
		displayValue: 'shared|contact|title|dr',
	},
	{
		value: ContactTitleEnum.NONE,
		displayValue: 'shared|contact|title|none',
	},
	{
		value: ContactTitleEnum.MR,
		displayValue: 'shared|contact|title|mr',
	},
	{
		value: ContactTitleEnum.MRS,
		displayValue: 'shared|contact|title|mrs',
	},
	{
		value: ContactTitleEnum.MS,
		displayValue: 'shared|contact|title|ms',
	},
	{
		value: ContactTitleEnum.MISS,
		displayValue: 'shared|contact|title|miss',
	},
	{
		value: ContactTitleEnum.PROF,
		displayValue: 'shared|contact|title|prof',
	},
	{
		value: ContactTitleEnum.SIR,
		displayValue: 'shared|contact|title|sir',
	},
];
